<aslib-title Text="Consulta/Distribuição Mensal aos Municípios" SubText="Consultar" Icon="fa fa-dollar"></aslib-title>
<form novalidate [formGroup]='formDistribuicaoMensal'>

  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Ano:<span>*</span></label>
    <div class="controls col-md-3">
      <select [(ngModel)]="anoSelected"  formControlName="Ano" class="form-control">
        <option [ngValue]=undefined>Selecione</option>
        <option *ngFor="let ano of listaAno" [ngValue]= "ano">{{ano.Descricao}}</option>
      </select>
    </div>
  </div>

  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Mês:<span>*</span></label>
    <div class="controls col-md-3">
      <select  [(ngModel)]="mesSelected" formControlName="Mes" class="form-control">
        <option [ngValue]=undefined>Selecione</option>
        <option *ngFor="let mes of listaMes"[ngValue]="mes">{{mes.Descricao}}</option>
      </select>
    </div>
  </div>


  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Tipo de Receita:</label>
    <div class="controls col-md-3">
      <select [(ngModel)]="tipoReceitaSelected"  formControlName="TipoReceita" class="form-control" (change)=" onChangeTipoReceita()" >
        <option value=undefined>Todos</option>
        <option *ngFor="let tipoReceita of listaTipoReceita" [ngValue]="tipoReceita">{{tipoReceita.Descricao}}</option>
      </select>
    </div>
  </div>

  <div class="form-group row">
    <div class="controls col-md-9 offset-md-3">
      <button type="submit" class="btn btn-primary" [disabled]="!formDistribuicaoMensal.valid" (click)="consultarDistribuicaoMensal(modalMensagem)" >
        <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Aplicar Filtro
      </button>
    </div>
  </div>

  <div class="form-group row mb-5" *ngIf="exibirGrid" >
    <aslib-grid id="as-grid" class="col-md-12" [(dataset)]="distribuicaoMensalMunicipioModelView.ListaDistribuicaoMensalMunicipio" [pagination]="true">
      
      <aslib-grid-column [property]="'DescricaoMunicipio'" [header]="'Município'" [width]="200" [sortable]="true"></aslib-grid-column>

      <aslib-grid-column [property]="'ValorCreditadoIcms'"  [width]="50" [header]="'Valor Icms'"  [sortable]="true">
        <ng-template #AslibGridCell let-item="item">
          <span>{{ item.ValorCreditadoIcms | trocarDeVirgulaParaPonto}}</span>
        </ng-template>
     </aslib-grid-column>

      <aslib-grid-column [property]="'ValorCreditadoIpi'"  [width]="50" [header]="'Valor Ipi'"  [sortable]="true">
        <ng-template #AslibGridCell let-item="item">
          <span>{{ item.ValorCreditadoIpi | trocarDeVirgulaParaPonto}}</span>
        </ng-template>
      </aslib-grid-column>

      <aslib-grid-column [property]="'ValorCreditadoipva'"  [width]="50" [header]="'Valor Ipva'"  [sortable]="true">
        <ng-template #AslibGridCell let-item="item">
          <span>{{ item.ValorCreditadoipva | trocarDeVirgulaParaPonto}}</span>
        </ng-template>
      </aslib-grid-column>

      <aslib-grid-column [property]="'ValorCreditadoFies'"  [width]="50" [header]="'Valor Fies'"  [sortable]="true">
        <ng-template #AslibGridCell let-item="item">
          <span>{{ item.ValorCreditadoFies | trocarDeVirgulaParaPonto}}</span>
        </ng-template>
      </aslib-grid-column>

      <aslib-grid-column [property]="'ValorCreditadoFcba'"  [width]="50" [header]="'Valor Fcba'"  [sortable]="true">
        <ng-template #AslibGridCell let-item="item">
          <span>{{ item.ValorCreditadoFcba | trocarDeVirgulaParaPonto}}</span>
        </ng-template>
      </aslib-grid-column>

    </aslib-grid>
  </div>


  <div class="form-group row"  *ngIf="exibirGrid">
    <div class="col-md-12">
      <button type="submit" class="btn btn-primary" (click)="gerarRelatorio(0)" [disabled]="!formDistribuicaoMensal.valid" >
        <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Pdf
      </button>
      <button type="submit" class="btn btn-primary" (click)="gerarRelatorio(1)" [disabled]="!formDistribuicaoMensal.valid" >
        <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Excel
      </button>
    </div>
  </div>

  
</form>
<aslib-modal #modalMensagem></aslib-modal>



// WEBPACK FOOTER //
// ./src/app/consulta/distribuicao-mensal-aos-municipio/distribuicao-mensal-municipio.component.html